﻿var tableFilter = (function () {
    var selectedYear, $yearSelect;
    function changeYear(y) {
        console.log("Change year", y);
        selectedYear = y;
        updateColumns();
    }
    //copy data attributes to related TDs
    function updateColumns() {
        $('[data-year]').each(function (i, e) {
            var y = $(e).attr('data-year');
            var child = i + 2;
            console.log(y, i, child);
            if (y == selectedYear) {
                $('table.financial tr td:nth-child(' + child + ')').removeClass().addClass('d-table-cell');
                $('table.financial tr th:nth-child(' + child + ')').removeClass(['d-none', 'd-md-table-cell', 'd-table-cell']).addClass('d-table-cell');
            } else {
                $('table.financial tr td:nth-child(' + child + ')').removeClass().addClass(['d-none', 'd-md-table-cell']);
                $('table.financial tr th:nth-child(' + child + ')').removeClass(['d-none', 'd-md-table-cell','d-table-cell']).addClass(['d-none', 'd-md-table-cell']);
            }
        });
    }

    function populateYearOptions($yearSelect) {
        // build options based on data n the table
        var allYearOptions = $('[data-year]').map(function () { return '<option value="' + $(this).data('year') + '">' + $(this).data('year') + '</option>' }).get().join('')
        $yearSelect.empty().append(allYearOptions);
        return $yearSelect.find(":selected").text(); // return current year
    }

    return {
        init: function () {
            console.log("Called tableFilter!");
            if ($('table.financial').length > 0) {
                $yearSelect = $('#yearFilter');
                // build year list in select
                var year = populateYearOptions($yearSelect);
                // init table
                changeYear(year);
                // hook mobile dropdown to change table col visibility
                $yearSelect.on('change', function () {
                    var yr = $yearSelect.find(":selected").text();
                    console.log("change", yr);
                    changeYear(yr);
                });
            }
        }
    };
})();

$(document).ready(function () {
    tableFilter.init();
});